/**
 * @generated SignedSource<<baf0b0742d6d8408de9e0e05064029ba>>
 * @relayHash 2eec6b3ac944870a7beffe63dd43e213
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID edefa586383073d18e29ae310cfd9d8eec687f473b49547ddb5d562c5012fdec

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BoardViewSettingsDataResolverQuery } from './BoardViewSettingsDataResolverQuery.graphql';

const node: PreloadableConcreteRequest<BoardViewSettingsDataResolverQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "edefa586383073d18e29ae310cfd9d8eec687f473b49547ddb5d562c5012fdec",
    "metadata": {},
    "name": "BoardViewSettingsDataResolverQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
